import { useState, createContext, useContext, useCallback } from "react";

const SampleContext = createContext();

export function SampleProvider(props) {
  const [wasatchSample, setWasatchSample] = useState({
    presumed: "",
    presumedSubDescription: "",
    colour: [],
    texture: [],
    bulk: [],
    trace: [],
    geometry: {},
    sampleImages: [],
  });

  const [device, setDevice] = useState();
  const [scanHistory, setScanHistory] = useState({
    bulk: [],
    trace: [],
  });

  const setCalibrationDevice = useCallback((calibrationDevice) => {
    setDevice(calibrationDevice);
  }, []);

  const setPresumedSubstance = useCallback((substance, description) => {
    setWasatchSample((prev) => ({
      ...prev,
      presumed: substance,
      presumedSubDescription: description,
    }));
  }, []);

  const setColour = useCallback((colour) => {
    setWasatchSample((prev) => ({ ...prev, colour: colour }));
  }, []);

  const setTexture = useCallback((texture) => {
    setWasatchSample((prev) => ({ ...prev, texture: texture }));
  }, []);

  const setGeometry = useCallback((location) => {
    setWasatchSample((prev) => ({ ...prev, geometry: location }));
  }, []);

  const initWasatchBulk = useCallback((sequences) => {
    setWasatchSample((prev) => ({ ...prev, bulk: sequences }));
  }, []);

  const initWasatchTrace = useCallback((sequences) => {
    setWasatchSample((prev) => ({ ...prev, trace: sequences }));
  }, []);

  const initWasatchBackground = useCallback((sequences) => {
    setWasatchSample((prev) => ({ ...prev, background: sequences }));
  }, []);

  const setScanResults = useCallback((scanType, results) => {
    setScanHistory((prev) => ({
      ...prev,
      [scanType]: results,
    }));
  }, []);

  const resetSampleData = useCallback(() => {
    setWasatchSample({
      presumed: "",
      presumedSubDescription: "",
      colour: [],
      bulk: [],
      trace: [],
      texture: [],
      geometry: {},
    });
    setScanHistory({
      bulk: [],
      trace: [],
    });
  }, []);

  return (
    <SampleContext.Provider
      value={{
        wasatchSample,
        device,
        scanHistory,
        setCalibrationDevice,
        setPresumedSubstance,
        setColour,
        setTexture,
        setGeometry,
        initWasatchBulk,
        initWasatchTrace,
        initWasatchBackground,
        resetSampleData,
        setScanResults,
      }}
    >
      {props.children}
    </SampleContext.Provider>
  );
}
export const useSampleContext = () => {
  const {
    wasatchSample,
    device,
    scanHistory,
    setCalibrationDevice,
    setPresumedSubstance,
    setColour,
    setTexture,
    setGeometry,
    initWasatchBulk,
    initWasatchTrace,
    initWasatchBackground,
    resetSampleData,
    setScanResults,
  } = useContext(SampleContext);
  return {
    wasatchSample,
    device,
    scanHistory,
    setCalibrationDevice,
    setPresumedSubstance,
    setColour,
    setTexture,
    setGeometry,
    initWasatchBulk,
    initWasatchTrace,
    initWasatchBackground,
    resetSampleData,
    setScanResults,
  };
};
